import {Container} from "./BrokerCertificateListItem.styled";

const BrokerCertificateListItem = () => {
  return <Container>
    broker certificate list item
  </Container>

}

export default BrokerCertificateListItem